import DetailsPage from './details-page.vue'
export default DetailsPage